// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.offence-details-section {
  display: flex;
  flex-direction: column;
}

.offence-details-section .section-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px 0;
  padding: 0;
  color: var(--ceoTrackTitleColor);
  user-select: none;
}

.offence-details-section dl {
  margin: 0;
}

.offence-details-section .NoticeDetailRow {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  align-items: center;
}

.offence-details-section .NoticeDetailRow dt {
  font-weight: 400;
  color: var(--tooltipBackgroundColor);
  min-width: 200px;
  margin: 0;
}

.offence-details-section .NoticeDetailRow dd {
  margin: 0;
  color: var(--ceoTrackTitleColor);
  font-weight: 400;
  flex: 1;
  min-width: 0;
}

.offence-details-section .contravention-code-row {
  position: relative;
}

.offence-details-section .contravention-code-row dd {
  flex: 1;
}

.offence-details-section .edit-icon-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  margin-left: 8px;
  transition: opacity 0.2s ease;
}

.offence-details-section .edit-icon-wrapper:hover {
  opacity: 0.7;
}

.offence-details-section .edit-icon-wrapper:focus {
  outline: 2px solid var(--edit-icon-color);
  outline-offset: 2px;
  border-radius: 4px;
}

.offence-details-section .contravention-edit-icon {
  width: 20px;
  height: 20px;
}

.offence-details-section .contravention-edit-container {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.offence-details-section .contravention-autocomplete {
  flex: 1;
}

.offence-details-section .save-icon-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  transition: opacity 0.2s ease;
}

.offence-details-section .save-icon-wrapper.save-icon-wrapper-disabled {
  cursor: not-allowed;
  opacity: 0.4;
  pointer-events: none;
}

.offence-details-section .save-icon-wrapper:hover {
  opacity: 0.7;
}

.offence-details-section .save-icon-wrapper:focus {
  outline: 2px solid var(--edit-icon-color);
  outline-offset: 2px;
  border-radius: 4px;
}

.offence-details-section .contravention-save-icon {
  color: var(--edit-icon-color);
  width: 24px;
  height: 24px;
}
.offence-details-section
  .contravention-edit-container
  .autoCompleteLazyLoadctrl
  .autoCompleteLazyLoadinputDiv {
  background-color: var(--button-secondary-color);
  border: var(--inputControlBorderSize) solid var(--submenufontcolour);
}
.offence-details-section
  .contravention-edit-container
  .autoCompleteLazyLoadctrl
  .autoCompleteInput {
  background-color: var(--button-secondary-color) !important;
}
.offence-details-section
  .contravention-edit-container
  .autoCompleteLazyLoadctrl
  .colWiseControl {
  gap: 0px;
}

.decreasePopperHeight {
  min-width: 320px !important;
  width: 320px !important;
}

.decreasePopperHeight .MuiAutocomplete-listbox {
  max-height: 240px;
}

.decreasePopperHeight .MuiAutocomplete-option {
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
}

.offence-details-section .contravention-notes-row {
  align-items: flex-start;
}

.offence-details-section .contravention-notes-value {
  white-space: pre-line;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/manualReviewTab/components/OffenceDetailsSection/OffenceDetailsSection.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;AACA;;;;EAIE,+CAA+C;EAC/C,oEAAoE;AACtE;AACA;;;;EAIE,0DAA0D;AAC5D;AACA;;;;EAIE,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.offence-details-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.offence-details-section .section-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0 0 12px 0;\n  padding: 0;\n  color: var(--ceoTrackTitleColor);\n  user-select: none;\n}\n\n.offence-details-section dl {\n  margin: 0;\n}\n\n.offence-details-section .NoticeDetailRow {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 12px;\n  align-items: center;\n}\n\n.offence-details-section .NoticeDetailRow dt {\n  font-weight: 400;\n  color: var(--tooltipBackgroundColor);\n  min-width: 200px;\n  margin: 0;\n}\n\n.offence-details-section .NoticeDetailRow dd {\n  margin: 0;\n  color: var(--ceoTrackTitleColor);\n  font-weight: 400;\n  flex: 1;\n  min-width: 0;\n}\n\n.offence-details-section .contravention-code-row {\n  position: relative;\n}\n\n.offence-details-section .contravention-code-row dd {\n  flex: 1;\n}\n\n.offence-details-section .edit-icon-wrapper {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  margin-left: 8px;\n  transition: opacity 0.2s ease;\n}\n\n.offence-details-section .edit-icon-wrapper:hover {\n  opacity: 0.7;\n}\n\n.offence-details-section .edit-icon-wrapper:focus {\n  outline: 2px solid var(--edit-icon-color);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.offence-details-section .contravention-edit-icon {\n  width: 20px;\n  height: 20px;\n}\n\n.offence-details-section .contravention-edit-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n}\n\n.offence-details-section .contravention-autocomplete {\n  flex: 1;\n}\n\n.offence-details-section .save-icon-wrapper {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  transition: opacity 0.2s ease;\n}\n\n.offence-details-section .save-icon-wrapper.save-icon-wrapper-disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.offence-details-section .save-icon-wrapper:hover {\n  opacity: 0.7;\n}\n\n.offence-details-section .save-icon-wrapper:focus {\n  outline: 2px solid var(--edit-icon-color);\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.offence-details-section .contravention-save-icon {\n  color: var(--edit-icon-color);\n  width: 24px;\n  height: 24px;\n}\n.offence-details-section\n  .contravention-edit-container\n  .autoCompleteLazyLoadctrl\n  .autoCompleteLazyLoadinputDiv {\n  background-color: var(--button-secondary-color);\n  border: var(--inputControlBorderSize) solid var(--submenufontcolour);\n}\n.offence-details-section\n  .contravention-edit-container\n  .autoCompleteLazyLoadctrl\n  .autoCompleteInput {\n  background-color: var(--button-secondary-color) !important;\n}\n.offence-details-section\n  .contravention-edit-container\n  .autoCompleteLazyLoadctrl\n  .colWiseControl {\n  gap: 0px;\n}\n\n.decreasePopperHeight {\n  min-width: 320px !important;\n  width: 320px !important;\n}\n\n.decreasePopperHeight .MuiAutocomplete-listbox {\n  max-height: 240px;\n}\n\n.decreasePopperHeight .MuiAutocomplete-option {\n  white-space: normal;\n  word-break: break-word;\n  line-height: 1.4;\n}\n\n.offence-details-section .contravention-notes-row {\n  align-items: flex-start;\n}\n\n.offence-details-section .contravention-notes-value {\n  white-space: pre-line;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
